module.exports = __webpack_public_path__ + "static/img/icon_szh_zhptyy_ny_fbs.9492046e.png";